import attachment from '@/router/system/attachment/attachment'
import container from '@/router/system/attachment/container'
import bucket from  '@/router/system/attachment/bucket'


export default {
  path: 'attachment',
  meta: {
    label: 'attachment',
    auth: 'attachment'
  },
  component: {
    name: 'Attachment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    attachment,
    container,
    bucket
  ]
}